import React from "react";

import { useAuth } from "@/auth/useAuth";

export function DashboardPage(): React.ReactElement {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Здравствуйте, {user?.username}</h1>
        <p className="text-sm text-muted-foreground">
          Портал продавца — модули появляются по мере готовности.
        </p>
      </div>

      <div className="text-xs text-muted-foreground">
        Текущий этап: аутентификация, права пользователей и подключение 1С УНФ.
        Следующий модуль — работа с отзывами маркетплейсов.
      </div>
    </div>
  );
}
